class FitTitle {
    constructor() {
        this.DOM = {
            titles: document.querySelectorAll('.fit-title')
        };

        if (this.DOM.titles.length < 1) {
            return; // No elements to process
        }

        this.observer = new ResizeObserver(() => {
            this.setFitTitle();
        });

        this.DOM.titles.forEach((title) => {
            this.observer.observe(title.parentElement);
        });

        this.setFitTitle();

        window.addEventListener('load', () => {
            this.setFitTitle();
        });
    }

    setFitTitle() {
        const isMobile = window.matchMedia('(max-width: 600px)').matches;

        this.DOM.titles.forEach((title) => {
            const parent = title.parentElement;
            const parentWidth = parent.getBoundingClientRect().width;
            // console.log('parentWidth', parentWidth);
            // Reset font size before measuring
            title.style.fontSize = '100px';
            title.style.opacity = 0;
            // Create a measurement clone
            const measure = title.cloneNode(true);

            measure.style.position = 'absolute';
            measure.style.visibility = 'hidden';
            measure.style.pointerEvents = 'none';
            measure.style.width = 'max-content';
            measure.style.whiteSpace = 'nowrap';
            measure.style.fontSize = '100px';

            document.body.appendChild(measure);

            let textWidth;

            if (isMobile) {
                // Fit the widest word so wrapped lines never overflow
                const words = title.textContent.trim().split(/\s+/);

                textWidth = Math.max(
                    ...words.map((word) => {
                        measure.textContent = word;
                        return measure.getBoundingClientRect().width;
                    })
                );
            } else {
                textWidth = measure.getBoundingClientRect().width;
            }

            // Scale the font size to fit the parent
            const fontSize = 100 * (parentWidth / textWidth);

            title.style.fontSize = `calc(${fontSize}px + 0.055em)`;
            title.style.opacity = 1;
            measure.remove();
        });
    }
}

new FitTitle();
